module.controller('verificationCtrl', ['accountService', '$scope', '$rootScope', '$state', '$http','baseURI', 'Transform', '$stateParams', '$window', '$q', 'Session', 'OVERLAY', function(accountService, $scope, $rootScope, $state, $http, baseURI, Transform, $stateParams, $window, $q, Session, OVERLAY){

  $scope.overlay = OVERLAY['member.home.profile/verification'];
  $scope.close = true;
  $scope.waitingForAttempt = true;
  $scope.loading = false;
  $scope.verificationFooterResponseNext = true;
  $scope.secondaryAlert = {alertShown: false};
  var fraudBlocked = false;
  var fraudInfoTxt = "Verification is required.";
  //text constants
  $scope.pollingStoppedMessage = 'The verification process has timed out. Please try to verify your account again or contact support.';
  $scope.verificationTxt = "Please check your mobile device for a text message link to continue document verification. You can also scan this QR code with your mobile device to continue document verification.";
  $scope.reviewTxt = 'We have received the identifying documentation you submitted.  In order to complete this verification process, please contact a member of our customer service team by calling ' + $scope.brand.programContactPhone + ' 7am - 7pm Central Time, Monday-Friday, or email us at ' + $scope.brand.programContactEmail;
  $scope.submitTxt = "Your documents were submitted. Please wait for the approval.";
  $scope.approvedTxt = "You've successfully completed the document verification process and your account is now available for use! You may continue on to view your balance and account details.";
  $scope.deniedTxt = "Unfortunately, we were unable to process the identifying documentation you submitted.  Please try to resubmit your driver's license or passport.";
  var fraudTxt = "A restriction has been placed on your account and it will be released once we are able to confirm your identify and validate any suspicious activity.";
  var enrollmentVerificationTxt = 'To verify your identity, we\'ll need some additional pieces of information. In the next steps, you will use your mobile device to upload identification documents.';
  var status = '';
  var pollingTimer;
  var pollingActive = false;
  var pollingStartTime;
  var pollingDuration = 10 * 60 * 1000;

  var getStatus = function(){
    $http({
      method: 'GET',
      url: baseURI + 'id/verification/status',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
    })
    .then(function(response){
      status = response.data.Data;
        if(status === 'Submitted'){
            $state.go('member.home.profile/verification.submitted');
        }
        else if (status === 'Approved'){
            $state.go('member.home.profile/verification.step3');
        }
        else if (status === 'Denied'){
            $state.go('member.home.profile/verification.denied');
        }
        else if (status === 'Review'){
          $state.go('member.home.profile/verification.review');
        }

    })
    .catch(function(error){
      console.catch('Error:', error);
    });
  };

  getStatus();

  $scope.reVerifyAccount = function(){
    $scope.waitingForAttempt = true;
    $state.go('member.home.profile/verification.step1');
  };

  $scope.alert = {};
  $scope.alert.alertShown = false;
  $scope.alert.alertMessage = 'We\'re currently processing your card, and are unable to update your address at this time. ' +
      'If you entered an incorrect address when you joined ' + $scope.brand.programName + ', please contact customer service at (855) 525-4626';
  $scope.attempted = false;

  //if the primary account is fraud blocked
  if(Session.getIsFraudBlocked() && $rootScope.hasMainAccess){
    fraudBlocked = true;
    $scope.info = fraudInfoTxt;
    $scope.helperText2 = fraudTxt;
  } else if(Session.getIsFraudBlocked()){ // the sub account is fraud blocked
    fraudBlocked = true;
    $scope.info = fraudInfoTxt;
    $scope.helperText2 = fraudTxt;
  } else if(Session.getEnrollmentErrorCode() === 150){
    $scope.info = fraudInfoTxt;
    $scope.helperText1 = enrollmentVerificationTxt;
    $scope.helperText2 = "The restriction on your account will be released once we are able to confirm your identify.";
    $scope.mainBtn = {
      attemptSubmission: false,
      title: ''
    };
  }

  $scope.attemptSubmission = function (formData){
    $scope.waitingForAttempt = false;
    $scope.verificationFooterResponse = true;
    $scope.respSuccess = false;
    var redirectLink = 'https://app.akimbocard.com';
    var request = {};
    request.Phone = formData.Phone.$viewValue;
    request.RedirectUrl = redirectLink;
    socureQRCodeRequest(request);
    if(formData.$valid){
      $scope.alert.errorShown = false;
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  $scope.processForm = function(){
  };

  $scope.$on('$destroy', function() {
    $scope.stopPolling();
  });

  $scope.startPolling = function () {
    if (!pollingActive) {
      pollingActive = true;
      pollingStartTime = Date.now();
      pollEndpoint();
    }
  };

  $scope.stopPolling = function () {
    pollingActive = false;
    if (pollingTimer) {
      clearTimeout(pollingTimer);
      pollingTimer = null;
    }
  };

  function pollEndpoint() {
    if (!pollingActive) {
      return;
    } else {
      $http({
        method: 'GET',
        url: baseURI + 'id/verification/status',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      })
          .then(function (response) {
            var socureStatus = response.data.Data;
            var elapsedTime = Date.now() - pollingStartTime;
            if (elapsedTime < pollingDuration) {
              if (socureStatus === 'Submitted') {
                $scope.loading = true;
                $state.go('member.home.profile/verification.submitted');
              }
              if (socureStatus === 'Approved') {
                setTimeout(function () {
                  $scope.loading = false;
                  $scope.verificationFooterResponseNext = false;
                  Session.setEnrollmentErrorCode(0);

                  // refetch cards
                  var refetchAccounts = true;
                  accountService.initializeAccounts(null, refetchAccounts);
                  if (pollingActive) {
                    Session.setEnrollmentErrorCode(0);
                    $state.go('member.home.profile/verification.step3');
                    $scope.stopPolling();
                  }
                }, 3000);
              }
              if (socureStatus === 'Denied') {
                $scope.stopPolling();
                $scope.loading = false;
                $state.go('member.home.profile/verification.denied');
              }
              if (socureStatus === 'Review') {
                $scope.stopPolling();
                $scope.loading = false;
                $state.go('member.home.profile/verification.review');
              }
              pollingTimer = setTimeout(pollEndpoint, 10000);
            } else {
              $scope.loading = false;
              $scope.stopPolling();
              pollingActive = false;
            }
          })
          .catch(function (error) {
            console.catch('Error:', error);
            if (pollingActive) {
              pollingTimer = setTimeout(pollEndpoint, 5000);
            }
          });
    }
  }

  function socureQRCodeRequest (request){
    $http({
      method: 'POST',
      url: baseURI + 'id/verification/url',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      $scope.qrCodeImageSrc = data.Data.qrCode;
      $q.when().then(function () {
        $scope.respSuccess = true;
        $scope.startPolling();
        $scope.loading = true;
        $state.go('member.home.profile/verification.step2');
      });
    }).catch(function(e){
      $scope.respSuccess = true;
      $scope.alert.errorShown = true;
      $scope.alert.alertMessage = 'Looks like there was an issue getting your document verification link try again in a few minutes or contact support.';
      $scope.attempted = true;
    });
  }
}]);
